/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { RootState } from '../store.typings';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { documentsClient } from '../api/documents/documentsClient';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import {
    DocumentDetailsPictAction,
    DocumentDetailsPictActionType,
    fetchDocumentPictSuccessAction,
    fetchDocumentPictErrorAction,
} from '../actions/documentDetailsPictActions';

type DocumentDetailsPictEpic = Epic<DocumentDetailsPictAction, DocumentDetailsPictAction, RootState>;

export const fetchDocumentPictEpic: DocumentDetailsPictEpic = (action$, state$) => {
    return action$.pipe(
        ofType(
            DocumentDetailsPictActionType.OPEN_DOCUMENT_CARD_PICT_PAGE,
            DocumentDetailsPictActionType.FETCH_DOCUMENT_PICT_START,
        ),
        switchMap(() => {
            const { CashboxTaxNumber, CreatedAtUtc, DocumentIdHash } = state$.value.routerState.route.params;

            return from(documentsClient.getDocumentCardPict(CashboxTaxNumber, CreatedAtUtc, DocumentIdHash)).pipe(
                map((data) => {
                    return fetchDocumentPictSuccessAction(data);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchDocumentPictErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.failedToGetDocument')),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(DocumentDetailsPictActionType.EXIT_DOCUMENT_CARD_PICT_PAGE)),
            );
        }),
    );
};
